import { render } from "./addServiceModal.vue?vue&type=template&id=5182c91a"
import script from "./addServiceModal.vue?vue&type=script&lang=js"
export * from "./addServiceModal.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__